import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M13.5303 7.03033C13.8232 6.73744 13.8232 6.26256 13.5303 5.96967L8.75736 1.1967C8.46447 0.903807 7.98959 0.903807 7.6967 1.1967C7.40381 1.48959 7.40381 1.96447 7.6967 2.25736L11.9393 6.5L7.6967 10.7426C7.40381 11.0355 7.40381 11.5104 7.6967 11.8033C7.98959 12.0962 8.46447 12.0962 8.75736 11.8033L13.5303 7.03033ZM-6.55672e-08 7.25L13 7.25L13 5.75L6.55672e-08 5.75L-6.55672e-08 7.25Z",
  fill: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ArrowRightIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "arrow-right",
    width: "14",
    height: "13",
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})